// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-menu-animation {
  transition-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
  /* VERTICAL ANIMATION */
  /* HORIZONTAL ANIMATION */
}
.dropdown-menu-animation--direction-bottom-top,
.dropdown-menu-animation--direction-top-bottom {
  transition-property: opacity, transform;
}
.dropdown-menu-animation--direction-bottom-top {
  transform: translateY(1em);
  transform-origin: bottom;
}
.dropdown-menu-animation--direction-top-bottom {
  transform: translateY(-1em);
  transform-origin: top;
}
.dropdown-menu-animation--state-entering.dropdown-menu-animation--direction-top-bottom,
.dropdown-menu-animation--state-exiting.dropdown-menu-animation--direction-top-bottom,
.dropdown-menu-animation--state-exited.dropdown-menu-animation--direction-top-bottom {
  transform: translateY(-1em);
  opacity: 0;
}
.dropdown-menu-animation--state-entering.dropdown-menu-animation--direction-bottom-top,
.dropdown-menu-animation--state-exiting.dropdown-menu-animation--direction-bottom-top,
.dropdown-menu-animation--state-exited.dropdown-menu-animation--direction-bottom-top {
  transform: translateY(1em);
  opacity: 0;
}
.dropdown-menu-animation--state-entered.dropdown-menu-animation--direction-top-bottom,
.dropdown-menu-animation--state-entered.dropdown-menu-animation--direction-bottom-top {
  transform: translateY(0);
  opacity: 1;
}
.dropdown-menu-animation--direction-left-right {
  transition-property: width;
}
.dropdown-menu-animation--state-exited.dropdown-menu-animation--direction-left-right,
.dropdown-menu-animation--state-exiting.dropdown-menu-animation--direction-left-right,
.dropdown-menu-animation--state-entering.dropdown-menu-animation--direction-left-right {
  width: 0;
}
.dropdown-menu-animation--state-entered.dropdown-menu-animation--direction-left-right {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/components/dropdown-menu-animation/DropdownMenuAnimation.less"],"names":[],"mappings":"AAAA;EACI,6DAAA;EACF,uBAAuB;EACvB,yBAAyB;AAC3B;AACI;;EAEE,uCAAA;AACN;AAEI;EACE,0BAAA;EACA,wBAAA;AAAN;AAGI;EACE,2BAAA;EACA,qBAAA;AADN;AAII;;;EAGE,2BAAA;EACA,UAAA;AAFN;AAKI;;;EAGE,0BAAA;EACA,UAAA;AAHN;AAMI;;EAEE,wBAAA;EACA,UAAA;AAJN;AASI;EACE,0BAAA;AAPN;AAUI;;;EAGE,QAAA;AARN;AAWI;EACE,WAAA;AATN","sourcesContent":[".dropdown-menu-animation {\n    transition-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n\n    /* VERTICAL ANIMATION */\n\n    &--direction-bottom-top,\n    &--direction-top-bottom {\n      transition-property: opacity, transform;\n    }\n\n    &--direction-bottom-top {\n      transform: translateY(1em);\n      transform-origin: bottom;\n    }\n\n    &--direction-top-bottom {\n      transform: translateY(-1em);\n      transform-origin: top;\n    }\n\n    &--state-entering&--direction-top-bottom,\n    &--state-exiting&--direction-top-bottom,\n    &--state-exited&--direction-top-bottom {\n      transform: translateY(-1em);\n      opacity: 0;\n    }\n\n    &--state-entering&--direction-bottom-top,\n    &--state-exiting&--direction-bottom-top,\n    &--state-exited&--direction-bottom-top {\n      transform: translateY(1em);\n      opacity: 0;\n    }\n\n    &--state-entered&--direction-top-bottom,\n    &--state-entered&--direction-bottom-top {\n      transform: translateY(0);\n      opacity: 1;\n    }\n\n    /* HORIZONTAL ANIMATION */\n\n    &--direction-left-right {\n      transition-property: width;\n    }\n\n    &--state-exited&--direction-left-right,\n    &--state-exiting&--direction-left-right,\n    &--state-entering&--direction-left-right {\n      width: 0;\n    }\n\n    &--state-entered&--direction-left-right {\n      width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
